var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-base-table-body-cell',_vm._b({},'iv-base-table-body-cell',{ ..._vm.$attrs, ..._vm.$props },false),[_c('iv-input-switch',_vm._b({},'iv-input-switch',{ ..._vm.$attrs, ..._vm.$props, disabled: true },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }